require('../../upsales/common/resources/index.js');
require('../../upsales/common/resources/mailCampaign.js');
require('../../upsales/common/resources/mailCampaignInfo.js');
require('../../upsales/common/resources/self.js');
require('../../upsales/common/resources/session.js');
require('../../upsales/common/resources/activity.js');
require('../../upsales/common/resources/activityList.js');
require('../../upsales/common/resources/activityType.js');
require('../../upsales/common/resources/appointment.js');
require('../../upsales/common/resources/appointmentType.js');
require('../../upsales/common/resources/order.js');
require('../../upsales/common/resources/opportunity.js');
require('../../upsales/common/resources/contact.js');
require('../../upsales/common/resources/user.js');
require('../../upsales/common/resources/metadata.js');
require('../../upsales/common/resources/account.js');
require('../../upsales/common/resources/project.js');
require('../../upsales/common/resources/orderStage.js');
require('../../upsales/common/resources/user.js');
require('../../upsales/common/resources/product.js');
require('../../upsales/common/resources/productCategory.js');
require('../../upsales/common/resources/requestBuilder.js');
require('../../upsales/common/resources/salesReport.js');
require('../../upsales/common/resources/category.js');
require('../../upsales/common/resources/customField.js');
require('../../upsales/common/resources/linkedIn.js');
require('../../upsales/common/resources/lead.js');
require('../../upsales/common/resources/leadsources.js');
require('../../upsales/common/resources/leadchannels.js');
require('../../upsales/common/resources/lead2.js');
require('../../upsales/common/resources/campaign.js');
require('../../upsales/common/resources/visitor.js');
require('../../upsales/common/resources/accountCategory.js');
require('../../upsales/common/resources/accountCategoryType.js');
require('../../upsales/common/resources/accountRelation.js');
require('../../upsales/common/resources/contactCategory.js');
require('../../upsales/common/resources/contactCategoryType.js');
require('../../upsales/common/resources/contactRelation.js');
require('../../upsales/common/resources/leaderAccount.js');
require('../../upsales/common/resources/leaderPage.js');
require('../../upsales/common/resources/listView.js');
require('../../upsales/common/resources/role.js');
require('../../upsales/common/resources/mailTemplate.js');
require('../../upsales/common/resources/mail.js');
require('../../upsales/common/resources/mailAccount.js');
require('../../upsales/common/resources/score.js');
require('../../upsales/common/resources/event.js');
require('../../upsales/common/resources/soliditetClient.js');
require('../../upsales/common/resources/multiActions.js');
require('../../upsales/common/resources/form.js');
require('../../upsales/common/resources/formSubmit.js');
require('../../upsales/common/resources/lookerSSO.js');
require('../../upsales/common/resources/lookerDashboard.js');
require('../../upsales/common/resources/lookerExplore.js');
require('../../upsales/common/resources/lookerLook.js');
require('../../upsales/common/resources/mapping/generic.js');
require('../../upsales/common/resources/mapping/customfield.js');
require('../../upsales/common/resources/resetScore.js');
require('../../upsales/common/resources/document.js');
require('../../upsales/common/resources/documentTemplate.js');
require('../../upsales/common/resources/lookup.js');
require('../../upsales/common/resources/agreement.js');
require('../../upsales/common/resources/links.js');
require('../../upsales/common/resources/resourceHelper.js');
require('../../upsales/common/resources/pushNotifications.js');
require('../../upsales/common/resources/activityQuota.js');
require('../../upsales/common/resources/genericQuota.js');
require('../../upsales/common/resources/engage.js');
require('../../upsales/common/resources/export.js');
require('../../upsales/common/resources/file.js');
require('../../upsales/common/resources/report.js');
require('../../upsales/common/resources/apiKey.js');
require('../../upsales/common/resources/accountProfile.js');
require('../../upsales/common/resources/standardMailTemplate.js');
require('../../upsales/common/resources/userDefinedObject.js');
require('../../upsales/common/resources/userDefinedCategoryType.js');
require('../../upsales/common/resources/userDefinedCategory.js');
require('../../upsales/common/resources/esign.js');
require('../../upsales/common/resources/reportView.js');
require('../../upsales/common/resources/standardCreative.js');
require('../../upsales/common/resources/standardIntegration.js');
require('../../upsales/common/resources/allIWant.js');
require('../../upsales/common/resources/staticValues.js');
require('../../upsales/common/resources/findProspect.js');
require('../../upsales/common/resources/landingPageTemplate.js');
require('../../upsales/common/resources/companyTypeReport.js');
require('../../upsales/common/resources/clientForm.js');
require('../../upsales/common/resources/standardField.js');
require('../../upsales/common/resources/currency.js');
require('../../upsales/common/resources/trigger.js');
require('../../upsales/common/resources/clientParam.js');
require('../../upsales/common/resources/userParam.js');
require('../../upsales/common/resources/inviteCode.js');
require('../../upsales/common/resources/phoneCall.js');
require('../../upsales/common/resources/quicksearch.js');
require('../../upsales/common/resources/onboarding.js');
require('../../upsales/common/resources/masterClient.js');
require('../../upsales/common/resources/import.js');
require('../../upsales/common/resources/whatismyip.js');
require('../../upsales/common/resources/suggestEmail.js');
require('../../upsales/common/resources/emailDuplicates.js');
require('../../upsales/common/resources/segment.js');
require('../../upsales/common/resources/userDefinedDefinition.js');
require('../../upsales/common/resources/deleteLog.js');
require('../../upsales/common/resources/flow.js');
require('../../upsales/common/resources/currencyRate.js');
require('../../upsales/common/resources/agreementSettings.js');
require('../../upsales/common/resources/businessEmail.js');
require('../../upsales/common/resources/optIn.js');
require('../../upsales/common/resources/groupMailCategory.js');

require('../../upsales/common/resources/parsers/generic.js');
require('../../upsales/common/resources/parsers/helpers.js');
require('../../upsales/common/resources/parsers/account.js');
require('../../upsales/common/resources/parsers/agreement.js');
require('../../upsales/common/resources/parsers/adCampaign.js');
require('../../upsales/common/resources/parsers/custom.js');
require('../../upsales/common/resources/parsers/formula.js');
require('../../upsales/common/resources/parsers/form.js');
require('../../upsales/common/resources/parsers/order.js');
require('../../upsales/common/resources/parsers/contact.js');
require('../../upsales/common/resources/parsers/orderStage.js');
require('../../upsales/common/resources/parsers/product.js');
require('../../upsales/common/resources/parsers/accountProfile.js');
require('../../upsales/common/resources/parsers/mailTemplate.js');
require('../../upsales/common/resources/parsers/mailCampaign.js');
require('../../upsales/common/resources/parsers/standardMailTemplate.js');
require('../../upsales/common/resources/parsers/notifications.js');
require('../../upsales/common/resources/parsers/userDefinedObject.js');
require('../../upsales/common/resources/parsers/campaign.js');
require('../../upsales/common/resources/parsers/listView.js');
require('../../upsales/common/resources/parsers/esign.js');
require('../../upsales/common/resources/parsers/category.js');
require('../../upsales/common/resources/parsers/productCategory.js');
require('../../upsales/common/resources/parsers/standardField.js');
require('../../upsales/common/resources/parsers/staticValues.js');

require('../../upsales/common/resources/mappers/generic.js');
require('../../upsales/common/resources/mappers/helpers.js');
require('../../upsales/common/resources/mappers/account.js');
require('../../upsales/common/resources/mappers/order.js');
require('../../upsales/common/resources/mappers/contact.js');
require('../../upsales/common/resources/mappers/activity.js');
require('../../upsales/common/resources/mappers/userDefinedObject.js');
require('../../upsales/common/resources/mappers/esign.js');
